function checkNotifyMe(retryCount = 0, debug = false) {
  const maxRetries = 15;
  const retryDelay = 500;
  const productPageInfo = document.querySelector(".product-page-info");
  if (!productPageInfo) {
    retryOrGiveUp();
    return;
  }

  const atcWrapper = productPageInfo.querySelector(
    "[data-js-footbar-product-limit]"
  );

  const addToCartButton = productPageInfo.querySelector(
    ".js-product-button-add-to-cart"
  );
  if (!addToCartButton) {
    if (debug) console.warn("No add to cart button found.");
    retryOrGiveUp();
    return;
  }

  const notifyMeButton = productPageInfo.querySelector(".klaviyo-bis-trigger");
  if (!notifyMeButton) {
    if (debug) console.warn("No notify me button found.");
    retryOrGiveUp();
    return;
  }
  function getCurrentVariantId() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("variant");
  }

  function handleNotifyMeClick() {
    const variantId = getCurrentVariantId();
    if (variantId) {
      const iframe = document.querySelector("#klaviyo-bis-iframe");
      if (!iframe) {
        if (debug) console.warn("Klaviyo iframe not found.");
        return;
      }
      const variantSelectInput = iframe.contentDocument.querySelector(
        "#variant_select input"
      );

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get("variant");
      if (variantSelectInput && variantId) {
        variantSelectInput.value = variantId;
        if (debug) console.log("Variant ID set in Klaviyo iframe:", variantId);
      } else {
        if (debug) console.warn("Variant input or variant ID not found.");
      }
    }
  }

  notifyMeButton.classList.add("btn--size-large");
  notifyMeButton.style.marginBottom = "25px";
  // notifyMeButton.addEventListener("click", handleNotifyMeClick);
  notifyMeButton.parentElement.addEventListener("click", () => {
    setTimeout(() => {
      handleNotifyMeClick();
    }, 100);
  });

  function toggleNotifyMeButton() {
    const isSoldOut =
      addToCartButton.getAttribute("data-button-status") === "sold-out";

    if (isSoldOut) {
      notifyMeButton.style.display = "flex";
      addToCartButton.style.display = "none";
      if (atcWrapper) atcWrapper.style.display = "none";
    } else {
      notifyMeButton.style.display = "none";
      addToCartButton.style.display = "block";
      if (atcWrapper) atcWrapper.style.display = "block";
    }
  }

  toggleNotifyMeButton();

  const observer = new MutationObserver(toggleNotifyMeButton);
  observer.observe(addToCartButton, {
    attributes: true,
    attributeFilter: ["data-button-status"],
  });

  function retryOrGiveUp() {
    if (retryCount < maxRetries) {
      if (debug)
        console.log(
          `Retrying checkNotifyMe (attempt ${retryCount + 1} of ${maxRetries})`
        );
      setTimeout(() => checkNotifyMe(retryCount + 1, debug), retryDelay);
    } else {
      if (debug)
        console.warn(
          `Failed to find notify me button after ${maxRetries} attempts`
        );
    }
  }
}

checkNotifyMe();
